export default "__VITE_ASSET__DhuSDxbP__"